export function between(value: number, a: number, b: number, maxIncluded = true, minIncluded = true) {
  const min = Math.min(a, b);
  const max = Math.max(a, b);

  return (value > min || (value === min && minIncluded)) && (value < Math.max(a, b) || (value === max && maxIncluded));
}
